import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import { IntegrationsSectionProps } from './types';
import IntegrationsSectionProvider from './Context';
import IntegrationsSectionStores from './Stores';
import IntegrationsSectionDataTable from './DataTable';
import IntegrationsSectionDialogs from './Dialogs';

const IntegrationsSection = ({
  list,
  loading,
  reload,
  hiddenTableEmpty = false,
}: IntegrationsSectionProps): ReactElement => (
  <IntegrationsSectionProvider
    value={{
      list,
      loading,
      reload,
      hiddenTableEmpty,
    }}
  >
    <Stack flex={1}>
      <IntegrationsSectionStores />

      <IntegrationsSectionDataTable />

      <IntegrationsSectionDialogs />
    </Stack>
  </IntegrationsSectionProvider>
);

export default IntegrationsSection;
